import { AnyAction } from "redux";
import { Dispatch } from "react";
import { Query, Result, } from "../../../../interfaces";
import { Find } from "../../../products";
import { Adapter } from "../../../../shared/adapter";
import { GroupAdapter } from "../../../../adapter/groups-adapter";
import { FindById } from "../../../groups";

export const FETCH_DATA_GROUPS_REQUEST = 'FETCH_DATA_GROUPS_REQUEST';
export const FETCH_DATA_GROUPS_SUCCESS = 'FETCH_DATA_GROUPS_SUCCESS';
export const FETCH_DATA_GROUPS_FAILURE = 'FETCH_DATA_GROUPS_FAILURE';
export const FETCH_DATA_GROUP = 'FETCH_DATA_GROUP';

interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchDataGroupsRequest = () => {
    return {
        type: FETCH_DATA_GROUPS_REQUEST,
    };
};

const fetchDataGroupsSuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_DATA_GROUPS_SUCCESS,
        payload: data
    };
};

const fetchDataGroup = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_DATA_GROUP,
        payload: data
    };
};

const fetchDataGroupsFailure = (error: any) => {
    return {
        type: FETCH_DATA_GROUPS_FAILURE,
        payload: error,
    };
};

export const find = (page: number, pageSize: number, query:Query) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchDataGroupsRequest());
        try {
            const response = await Find('groups', query, page, pageSize);

            dispatch(fetchDataGroupsSuccess(
                { 
                    meta : response.meta,
                    values : Adapter.from(response.data).to((value) => new GroupAdapter(value).adapt()) 
                }
            ));

        } catch (error: any) {
            dispatch(fetchDataGroupsFailure(error.message));
        }
    };
};

export const findById = (id:string) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchDataGroupsRequest());
        try {
            const response = await FindById(id, "?fields=*.*.*");
            dispatch(fetchDataGroup(Adapter.from(response.data).to((value) => new GroupAdapter(value).adapt())));
        } catch (error: any) {
            dispatch(fetchDataGroupsFailure(error.message));
        }
    };
};
